import React from 'react';
import { useLocation } from 'react-router-dom';
import { prop } from 'ramda';

import { ManagedPopup as ManagedPopupOriginal } from 'js/components/common/Popup/ManagedPopup';

import { useAppSelector } from 'js/store/hooks';
import { useUpdateEffect } from 'js/hooks/useUpdateEffect';
import { useOnClose } from 'js/components/common/PopupManager';

// it receives props from its wrapper component, which in turn receives props from
// PopupManager/Layer/PopupFactory chain. Most props are from popups store.
export const ManagedPopup = (props) => {
    const defaultOnClose = useOnClose();
    const pageInPopupUrls = useAppSelector(prop('pageInPopupUrls'));
    const { pathname, state } = useLocation();
    const { onClose = defaultOnClose } = props;

    useUpdateEffect(() => {
        if (
            !props.isNotCloseAfterRedirect
            && state?.prevPath
            && !pageInPopupUrls?.includes(state?.prevPath)
        ) {
            onClose();
        }
    }, [pathname]);

    return <ManagedPopupOriginal {...props} />;
};
